module.exports = __webpack_public_path__ + "images/otolift_small40bd94a1571e32aeb5771a093a9b7da8.png";